var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useEditableField } from '../../../hooks/use-editable-field';
import { Audience } from './audience';
import { AudienceOptions, ClientsCategories, DefaultSegments, LapsedClientsDescription, NewClientsDescription, ProspectiveClientsDescription, RegularClientsDescription, } from './types';
import { useAudienceClients } from '../../../hooks/use-audience-clients';
import { useAvailableAudiences } from '../../../hooks/use-available-audiences';
import { AUDIENCE_TYPE } from '../../../../../../../app/engagement/constants';
import { ShimmerBar } from '../../../../../../infra/ui/shimmer';
import styles from './styles.module.scss';
import { formatNumber } from '../../../../../../../app/common/Num';
import { getViewerIdAndKind, useSession, } from '../../../../../../infra/session';
import { COUNTRY_CODE_BY_CURRENCY } from '../../../../../../../app/main/shops/constants';
import { filterByTerm } from './filter-utils';
import { useCampaignDetails } from '../../../hooks';
import { useRouteParams } from '../../../../../../infra/routing';
export var AudienceContainer = function () {
    var _a, _b;
    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var session = useSession().data;
    var sessionView = session.view;
    var currency = (_c = sessionView.meta) === null || _c === void 0 ? void 0 : _c.currency;
    var campaignId = useRouteParams().campaignId;
    var campaign = useCampaignDetails(campaignId).campaign;
    var viewerIdAndKind = getViewerIdAndKind(session);
    // Security check: Only campaign owner can view client info
    var isViewerCampaignOwner = campaign ? campaign.ownerId === viewerIdAndKind.id : true;
    var _p = useEditableField('usesCustomAudiences'), customAudiencesField = _p.field, setCustomAudiencesValue = _p.setValue;
    var _q = useAudienceClients(), audiences = _q.audiences, setNewClients = _q.setNewClients, setNewClientsWeeks = _q.setNewClientsWeeks, setProspective = _q.setProspective, setRegular = _q.setRegular, setLapsing = _q.setLapsing, setClientsByService = _q.setClientsByService, setBarbersClients = _q.setBarbersClients, setShopClients = _q.setShopClients;
    var _r = (_d = audiences === null || audiences === void 0 ? void 0 : audiences.value) !== null && _d !== void 0 ? _d : {}, newClients = _r.newClients, regular = _r.regular, lapsing = _r.lapsing, prospective = _r.prospective, service = _r.service, barbers = _r.barbers, shops = _r.shops;
    var _s = useAvailableAudiences({
        newCustomerWeeks: newClients === null || newClients === void 0 ? void 0 : newClients.weeks,
    }), availableAudiences = _s.availableAudiences, isLoadingCounts = _s.isLoading;
    var _t = (_e = availableAudiences === null || availableAudiences === void 0 ? void 0 : availableAudiences.segments) !== null && _e !== void 0 ? _e : {}, defaultClients = _t.default, audienceByService = _t.service, barber = _t.barber, shop = _t.shop;
    var _u = useState(''), searchTerm = _u[0], setSearchTerm = _u[1];
    var filterList = function (items) { return filterByTerm(items, searchTerm); };
    var _v = useState((_a = {},
        _a[ClientsCategories.DEFAULT_CLIENTS] = false,
        _a[ClientsCategories.CLIENTS_BY_SERVICE] = false,
        _a[ClientsCategories.BARBERS_CLIENTS] = false,
        _a[ClientsCategories.SHOPS_CLIENTS] = false,
        _a)), showMore = _v[0], setShowMore = _v[1];
    var _w = useState((_b = {},
        _b[ClientsCategories.DEFAULT_CLIENTS] = false,
        _b[ClientsCategories.CLIENTS_BY_SERVICE] = false,
        _b[ClientsCategories.BARBERS_CLIENTS] = false,
        _b[ClientsCategories.SHOPS_CLIENTS] = false,
        _b)), showModalInfo = _w[0], setShowModalInfo = _w[1];
    var selectedAudienceType = (customAudiencesField === null || customAudiencesField === void 0 ? void 0 : customAudiencesField.value) ? AudienceOptions.CUSTOM : AudienceOptions.ALL_CLIENTS;
    var isServiceEnabled = function (serviceId) {
        return service.serviceId === serviceId && service.enabled;
    };
    var defaultSegments = __spreadArray([
        {
            title: DefaultSegments.NEW_CLIENTS,
            description: NewClientsDescription,
            value: newClients.enabled,
            setValue: setNewClients,
            clients: (_f = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                var name = _a.name;
                return name === AUDIENCE_TYPE.new;
            })) === null || _f === void 0 ? void 0 : _f.customers,
        },
        {
            title: DefaultSegments.REGULAR_CLIENTS,
            description: RegularClientsDescription,
            value: regular.enabled,
            setValue: setRegular,
            clients: (_g = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                var name = _a.name;
                return name === AUDIENCE_TYPE.regular;
            })) === null || _g === void 0 ? void 0 : _g.customers,
        },
        {
            title: DefaultSegments.LAPSED_CLIENTS,
            description: LapsedClientsDescription,
            value: lapsing.enabled,
            setValue: setLapsing,
            clients: (_h = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                var name = _a.name;
                return name === AUDIENCE_TYPE.lapsing;
            })) === null || _h === void 0 ? void 0 : _h.customers,
        }
    ], (COUNTRY_CODE_BY_CURRENCY[currency] === 'CA'
        ? []
        : [
            {
                title: DefaultSegments.PROSPECTIVE,
                description: ProspectiveClientsDescription,
                value: prospective.enabled,
                setValue: setProspective,
                clients: (_j = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                    var name = _a.name;
                    return name === AUDIENCE_TYPE.prospective;
                })) === null || _j === void 0 ? void 0 : _j.customers,
            },
        ]), true);
    var sortAlphabetically = function (a, b) {
        var labelA = a.title.toUpperCase();
        var labelB = b.title.toUpperCase();
        if (labelA < labelB)
            return -1;
        if (labelA > labelB)
            return 1;
        return 0;
    };
    var clientsByService = ((_k = audienceByService === null || audienceByService === void 0 ? void 0 : audienceByService.map(function (_a) {
        var label = _a.label, id = _a.id, customers = _a.customers;
        return ({
            title: label,
            value: isServiceEnabled(id),
            setValue: function (value) { return setClientsByService(id, value); },
            clients: customers,
        });
    })) !== null && _k !== void 0 ? _k : []).sort(sortAlphabetically);
    var clientsByBarber = isViewerCampaignOwner
        ? (_l = barber === null || barber === void 0 ? void 0 : barber.map(function (_a) {
            var _b;
            var label = _a.label, id = _a.id, customers = _a.customers;
            return ({
                title: label,
                value: !!((_b = barbers[id]) === null || _b === void 0 ? void 0 : _b.enabled),
                setValue: function (value) { return setBarbersClients(id, value); },
                clients: customers,
            });
        }).sort(sortAlphabetically)) !== null && _l !== void 0 ? _l : []
        : [];
    var clientsByShop = (_m = shop === null || shop === void 0 ? void 0 : shop.map(function (_a) {
        var _b;
        var label = _a.label, id = _a.id, customers = _a.customers;
        return ({
            title: label,
            value: !!((_b = shops[id]) === null || _b === void 0 ? void 0 : _b.enabled),
            setValue: function (value) { return setShopClients(id, value); },
            clients: customers,
        });
    }).sort(sortAlphabetically)) !== null && _m !== void 0 ? _m : [];
    var defaultSegmentsFiltered = filterList(defaultSegments);
    var clientsByServiceFiltered = filterList(clientsByService);
    var clientsByBarberFiltered = filterList(clientsByBarber);
    var clientsByShopFiltered = filterList(clientsByShop);
    var showNoResults = searchTerm.trim() !== '' &&
        defaultSegmentsFiltered.length === 0 &&
        clientsByServiceFiltered.length === 0 &&
        clientsByBarberFiltered.length === 0 &&
        clientsByShopFiltered.length === 0;
    var handleRenderAllClientsLabel = function () {
        var _a;
        return (_jsxs(_Fragment, { children: ["".concat(AudienceOptions.ALL_CLIENTS, " "), !isLoadingCounts &&
                    "(".concat(formatNumber((_a = defaultClients === null || defaultClients === void 0 ? void 0 : defaultClients.find(function (_a) {
                        var name = _a.name;
                        return name === AUDIENCE_TYPE.all;
                    })) === null || _a === void 0 ? void 0 : _a.customers), ")"), isLoadingCounts && _jsx(ShimmerBar, { className: styles['loading-bar'], width: "30px" })] }));
    };
    return (_jsx(Audience, { onSelectCustomAudiences: setCustomAudiencesValue, selectedAudienceType: selectedAudienceType, showModalInfo: showModalInfo, onShowModalInfo: setShowModalInfo, defaultSegments: defaultSegmentsFiltered, clientsByService: clientsByServiceFiltered, clientsByBarber: clientsByBarberFiltered, clientsByShop: clientsByShopFiltered, isLoadingCounts: isLoadingCounts, renderAllClientsLabel: handleRenderAllClientsLabel, onChangeNewClientsWeeks: setNewClientsWeeks, newClientsWeeks: (_o = newClients.weeks) === null || _o === void 0 ? void 0 : _o.toString(), showMore: showMore, onShowMore: setShowMore, setSearchTerm: setSearchTerm, noResults: showNoResults }));
};
